import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from "@reduxjs/toolkit";
import { setToken } from "../reducers/authSlice";

const clearToken = (api: MiddlewareAPI) => {
  api.dispatch(setToken(""));
  localStorage.removeItem("token");
};

export const authRedirect: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (action?.payload?.error) {
      const { error, message } = action.payload;

      switch (error) {
        case "Query error":
          console.error("Query error:", message);
          break;
        case "Token error":
          console.error("Token error:", message);
          clearToken(api);
      }
    }
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
    if (isRejectedWithValue(action)) {
      if (action.payload.status === 403) {
        clearToken(api);
      }
    }

    return next(action);
  };
